import type { SourcingEventV2Dto } from "../../../../autogen/bff-api";

// SourcingEventV2Dto.toDto keeps `award` after a withdrawal to carry the decision history, with `awardedAt` cleared.
export const hasStandingAwardDecision = (event: SourcingEventV2Dto): boolean => event.award?.awardedAt != null;
